import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../../../components/AnimatedSection/AnimatedSection';
import './JoinHeroSection.scss';

import joinPhoto1 from '../../../../assets/images/join/join-hero.jpg';
import joinPhoto2 from '../../../../assets/images/join/join-second.webp';

const JoinHeroSection = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    const scaleReveal = prefersReducedMotion
        ? {}
        : {
              initial: { opacity: 0, scale: 0.98 },
              whileInView: { opacity: 1, scale: 1 },
              viewport: { once: true, amount: 0.25 },
              transition: { duration: 1.2, delay: 0.2, ease: EASE_OUT_EXPO },
          };

    return (
        <section className="join-hero">
            <div className="join-hero__container">
                <div className="join-hero__grid">

                    <div className="join-hero__content">
                        <motion.h1 className="join-hero__title" {...fadeUp(0, 1.2)}>{t('join_hero_title')}</motion.h1>
                        <motion.p className="join-hero__description" {...fadeUp(0.15)}>
                            {t('join_hero_description')}
                        </motion.p>
                    </div>

                    <motion.div className="join-hero__image-first" {...scaleReveal}>
                        <img src={joinPhoto1} alt={t('alt_church_community')} />
                    </motion.div>

                    <motion.div className="join-hero__image-second-wrapper" {...fadeUp(0.3)}>
                        <div className="join-hero__image-second">
                            <img src={joinPhoto2} alt={t('alt_church_worship')} />
                        </div>
                        <p className="join-hero__address">{t('church_address')}</p>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default JoinHeroSection;